// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ci","summaryPar":"di","ratingCategories":"ei","reviewerInfo":"fi","reviewTypes":"gi","expanded":"hi"};